<template>
    <div class="o-search__box c-mobile-out">
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item fw-b">
                <button
                    class="nav-link"
                    :class="{ active: selectedTicketType != 'daytrip' }"
                    id="oneway-return-tab"
                    role="tab"
                    aria-controls="oneway-return"
                    aria-selected="true"
                    @click="setTicketType('oneway', $event)"
                    >Book a voyage</button>
            </li>
            <li class="nav-item fw-b">
                <button
                    class="nav-link"
                    :class="{ active: selectedTicketType == 'daytrip' }"
                    id="daytrip-tab"
                    role="tab"
                    aria-controls="daytrip"
                    aria-selected="false"
                    @click="setTicketType('daytrip', $event)"
                    >Venice day trip</button>
            </li>
        </ul>

        <div class="tab-content is-rounded">
            <div
                class="tab-pane fade"
                :class="{ 'show active': selectedTicketType != 'daytrip' }"
                id="oneway-return"
                role="tabpanel"
                aria-labelledby="oneway-return-tab"
                >
                <div class="o-search__traghetti">
                    <div class="o-search__radios">
                        <div class="form-group">
                            <label class="c-radio">
                                <input type="radio" name="searchType" value="oneway" v-model="selectedTicketType">
                                <span class="c-radio__icon"></span>
                                <span class="c-radio__txt">One way</span>
                            </label>
                        </div>
                        <div class="form-group">
                            <label class="c-radio">
                                <input type="radio" name="searchType" value="return" v-model="selectedTicketType">
                                <span class="c-radio__icon"></span>
                                <span class="c-radio__txt">Return</span>
                            </label>
                        </div>
                    </div>
                    <booking-search-oneway v-if="selectedTicketType=='oneway'"></booking-search-oneway>
                    <booking-search-return v-if="selectedTicketType=='return'" :multicity="multicity"></booking-search-return>
                </div>
            </div>

            <div
                class="tab-pane fade"
                :class="{ 'show active': selectedTicketType == 'daytrip' }"
                id="daytrip"
                role="tabpanel"
                aria-labelledby="daytrip-tab"
                >
                <booking-search-daytrip :min-daytrip-price="minDaytripPrice" v-if="selectedTicketType=='daytrip'" :multicity="multicity"></booking-search-daytrip>
            </div>
        </div>
    </div>
</template>

<script>
import BookingSearchDaytrip from './BookingSearchDaytrip.vue'
import BookingSearchOneway from './BookingSearchOneway.vue'
import BookingSearchReturn from './BookingSearchReturn.vue'
export default {
    props: [
        'minDaytripPrice'
    ],
    components: {
        BookingSearchDaytrip,
        BookingSearchOneway,
        BookingSearchReturn,
    },
    data() {
        return {
            selectedTicketType: 'oneway',
            multicity: false,
        }
    },
    mounted() {
        const params = new URLSearchParams(window.location.search)
        
        if (!params.get('ticket')) return

        if (params.get('ticket').includes('daytrip')) {
            this.selectedTicketType = 'daytrip'
        }
        else if (params.get('ticket').includes('return')) {
            this.selectedTicketType = 'return'
        }
        else {
            this.selectedTicketType = 'oneway'
        }

        this.multicity = params.get('ticket').includes('multicity')
    },
    methods: {
        setTicketType(type, e) {
            e.preventDefault()
            this.selectedTicketType = type
        }
    }
}
</script>